export default "__VITE_ASSET__C_TlDNj6__"